import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

const ErrorUI = ({ error, onRetry }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        height: "50vh",
        backgroundColor: "#fef8f8",
        border: "1px solid #f44336",
        borderRadius: "8px",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 48, color: "#f44336", mb: 2 }} />
      <Typography
        variant="h6"
        fontWeight="bold"
        color="#f44336"
        sx={{ mb: 1 }}
      >
        Something Went Wrong
      </Typography>
      <Typography variant="body1" color="#333" sx={{ mb: 2 }}>
        {error}
      </Typography>
      <Button
        variant="outlined"
        startIcon={<RefreshIcon />}
        onClick={onRetry}
        sx={{
          textTransform: "none",
          fontWeight: "bold",
          borderColor: "#1976d2",
          color: "#1976d2",
          "&:hover": {
            borderColor: "#1565c0",
            backgroundColor: "#e3f2fd",
          },
        }}
      >
        Retry
      </Button>
    </Box>
  );
};

export default ErrorUI; 